export * from './lib/multi-select.module';
